import React from 'react'
import { Modal, Button, Icon } from 'antd'
import './ConfirmationModal.scss'

const ConfirmationModal = ({
  visible,
  onCancel,
  onConfirm,
  title,
  content
}) => {
  return (
    <Modal
      visible={visible}
      onCancel={onCancel}
      footer={null}
      centered
      closable={false}
      width={600}
      className="shl-confirmation-modal"
    >
      <div className="shl-confirmation-modal__content">
        <div className="shl-confirmation-modal__icon-wrapper">
          <div className="shl-confirmation-modal__icon-bg">
            <Icon type="warning" className="shl-confirmation-modal__icon" />
          </div>
        </div>

        <h2 className="shl-confirmation-modal__title">
          {title || 'Confirm Changes'}
        </h2>

        <div className="shl-confirmation-modal__description">
          {content || 'Are you sure you want to proceed with these changes?'}
        </div>

        <div className="shl-confirmation-modal__actions">
          <Button
            className="shl-confirmation-modal__btn shl-confirmation-modal__btn--cancel"
            onClick={onCancel}
            size="large"
            shape="round"
          >
            Cancel
          </Button>
          <Button
            className="shl-confirmation-modal__btn shl-confirmation-modal__btn--confirm shl-primary-btn"
            onClick={onConfirm}
            type="primary"
            size="large"
            shape="round"
          >
            Proceed
          </Button>
        </div>
      </div>
    </Modal>
  )
}

export default ConfirmationModal
